/** Copies code/text to clipboard.
 *
 * @param {string} textToCopy - The text to be copied to the clipboard.
 * @returns {void} - The text is copied to the clipboard and nothing is returned.
 */

export const handleCopyClick = async (textToCopy: string) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
  } catch (error) {
    console.error('Failed to copy code: ', error);
  }
};
